export enum EmailType {
  Primary = 'primary',
  Verified = 'verified',
  Unverified = 'unverified',
}
